module.exports = __webpack_public_path__ + "img/bjjcgzc_tc_img.de877a15.png";